import { useTranslation } from 'react-i18next';

const ProductCategoriesSection = () => {
  const { t } = useTranslation('choHem');

  const categories = [
    {
      icon: 'ri-scissors-cut-line',
      title: t('categories.cat1.title'),
      desc: t('categories.cat1.desc'),
      image: 'https://public.readdy.ai/ai/img_res/530e4c22f90a0adcd38c678d18613afd.jpg',
      color: 'from-orange-500/20 to-amber-500/20',
      border: 'border-orange-400/20',
      tag: t('categories.cat1.tag'),
    },
    {
      icon: 'ri-t-shirt-line',
      title: t('categories.cat2.title'),
      desc: t('categories.cat2.desc'),
      image: 'https://readdy.ai/api/search-image?query=Colorful%20Asian%20traditional%20clothing%20display%20silk%20fabrics%20Vietnamese%20ao%20dai%20Korean%20hanbok%20Japanese%20kimono%20fabric%20rolls%20arranged%20beautifully%20in%20small%20boutique%20kiosk%20warm%20lighting%20clean%20simple%20background&width=600&height=400&seq=cat_cloth_01&orientation=landscape',
      color: 'from-rose-500/20 to-pink-500/20',
      border: 'border-rose-400/20',
      tag: t('categories.cat2.tag'),
    },
    {
      icon: 'ri-gem-line',
      title: t('categories.cat3.title'),
      desc: t('categories.cat3.desc'),
      image: 'https://readdy.ai/api/search-image?query=Asian%20jewelry%20accessories%20display%20elegant%20necklaces%20bracelets%20earrings%20jade%20stone%20ornaments%20hair%20accessories%20arranged%20on%20velvet%20display%20stand%20warm%20golden%20lighting%20simple%20clean%20background&width=600&height=400&seq=cat_jewelry_01&orientation=landscape',
      color: 'from-yellow-500/20 to-amber-400/20',
      border: 'border-yellow-400/20',
      tag: t('categories.cat3.tag'),
    },
    {
      icon: 'ri-restaurant-line',
      title: t('categories.cat4.title'),
      desc: t('categories.cat4.desc'),
      image: 'https://readdy.ai/api/search-image?query=Asian%20kitchen%20utensils%20display%20ceramic%20bowls%20chopsticks%20wok%20pans%20clay%20pots%20tea%20sets%20bamboo%20steamers%20arranged%20neatly%20on%20wooden%20shelves%20warm%20lighting%20clean%20simple%20background&width=600&height=400&seq=cat_kitchen_01&orientation=landscape',
      color: 'from-teal-500/20 to-emerald-500/20',
      border: 'border-teal-400/20',
      tag: t('categories.cat4.tag'),
    },
    {
      icon: 'ri-service-line',
      title: t('categories.cat5.title'),
      desc: t('categories.cat5.desc'),
      image: 'https://readdy.ai/api/search-image?query=Asian%20beauty%20salon%20nail%20service%20manicure%20pedicure%20station%20small%20kiosk%20setup%20professional%20tools%20colorful%20nail%20polish%20display%20clean%20modern%20interior%20warm%20lighting&width=600&height=400&seq=cat_service_01&orientation=landscape',
      color: 'from-violet-500/20 to-purple-500/20',
      border: 'border-violet-400/20',
      tag: t('categories.cat5.tag'),
    },
  ];

  return (
    <section className="py-14 md:py-24 bg-black" id="categories">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block px-3 py-1 bg-amber-500/15 border border-amber-400/30 rounded-full text-xs text-amber-300 font-semibold uppercase tracking-wider mb-3">
            {t('categories.badge')}
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white font-serif mb-3">
            {t('categories.title.line1')} <span className="text-amber-400">{t('categories.title.line2')}</span>
          </h2>
          <p className="text-gray-400 text-sm md:text-base max-w-2xl mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>

        {/* Mobile: horizontal scroll */}
        <div className="lg:hidden -mx-4 px-4">
          <div
            className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {categories.map((cat, i) => (
              <div
                key={i}
                className={`relative rounded-2xl overflow-hidden border ${cat.border} bg-gradient-to-br ${cat.color} flex-shrink-0 snap-start`}
                style={{ width: '72vw', maxWidth: '280px' }}
              >
                <div className="h-36 overflow-hidden relative">
                  <img
                    src={cat.image}
                    alt={cat.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/80"></div>
                </div>
                <div className="p-3">
                  <div className="flex items-center gap-2 mb-1.5">
                    <div className="w-7 h-7 flex items-center justify-center bg-amber-500/20 rounded-lg flex-shrink-0">
                      <i className={`${cat.icon} text-amber-400 text-sm`}></i>
                    </div>
                    <h3 className="text-white font-bold text-sm leading-tight">{cat.title}</h3>
                    <span className="ml-auto text-[9px] px-1.5 py-0.5 bg-amber-500/20 text-amber-300 rounded-full border border-amber-400/20 whitespace-nowrap flex-shrink-0">
                      {cat.tag}
                    </span>
                  </div>
                  <p className="text-gray-400 text-xs leading-relaxed line-clamp-3">{cat.desc}</p>
                </div>
              </div>
            ))}
          </div>
          {/* Scroll indicator dots */}
          <div className="flex justify-center gap-1.5 mt-2">
            {categories.map((_, i) => (
              <div key={i} className={`rounded-full bg-amber-400/40 ${i === 0 ? 'w-4 h-1.5' : 'w-1.5 h-1.5'}`}></div>
            ))}
          </div>
        </div>

        {/* Desktop: grid layout (unchanged) */}
        <div className="hidden lg:grid grid-cols-3 gap-6">
          {categories.map((cat, i) => (
            <div
              key={i}
              className={`relative rounded-2xl overflow-hidden border ${cat.border} bg-gradient-to-br ${cat.color} group hover:scale-[1.02] transition-all duration-300`}
            >
              <div className="h-44 md:h-52 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/80"></div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-amber-500/20 rounded-lg">
                    <i className={`${cat.icon} text-amber-400 text-base`}></i>
                  </div>
                  <h3 className="text-white font-bold text-sm md:text-base">{cat.title}</h3>
                  <span className="ml-auto text-[10px] px-2 py-0.5 bg-amber-500/20 text-amber-300 rounded-full border border-amber-400/20 whitespace-nowrap">
                    {cat.tag}
                  </span>
                </div>
                <p className="text-gray-400 text-xs md:text-sm leading-relaxed">{cat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCategoriesSection;